import { create } from 'zustand';

import type { BizyUserMessage } from '../../schemas/bizy-conversations';

interface BizyWidgetStore {
	isOpen: boolean;
	/** Conversation ID to resume when the widget opens */
	resumeConversationId: string | undefined;
	/** Pre-loaded messages for conversation rehydration */
	resumeMessages: BizyUserMessage[] | undefined;
	open: () => void;
	close: () => void;
	toggle: () => void;
	/** Open the widget with a previous conversation loaded for rehydration */
	openWithConversation: (conversationId: string, messages: BizyUserMessage[]) => void;
	/** Set resume data without opening the widget (used by the side panel) */
	setResume: (conversationId: string, messages: BizyUserMessage[]) => void;
	/** Clear the resume state (called after the chat hook consumes it) */
	clearResume: () => void;
}

export const useBizyWidgetStore = create<BizyWidgetStore>((set) => ({
	isOpen: false,
	resumeConversationId: undefined,
	resumeMessages: undefined,
	open: () => set({ isOpen: true }),
	close: () => set({ isOpen: false, resumeConversationId: undefined, resumeMessages: undefined }),
	toggle: () => set((state) => ({ isOpen: !state.isOpen })),
	openWithConversation: (conversationId, messages) => set({ isOpen: true, resumeConversationId: conversationId, resumeMessages: messages }),
	setResume: (conversationId, messages) => set({ resumeConversationId: conversationId, resumeMessages: messages }),
	clearResume: () => set({ resumeConversationId: undefined, resumeMessages: undefined }),
}));
